import Link from 'next/link';
import { useState, type AnchorHTMLAttributes } from 'react';

import { ArrowLeft, CaretRight } from '@/public/assets/icons';


import css from './header-mobile-menu.css';
import { LanguageSwitcher } from './language-switcher';

import type { HeaderDropdownGroup } from '../view-models/header-dropdown-group';

interface DropdownLinkItem {
  href: string;
  label: string;
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  groups: HeaderDropdownGroup[];
}

export const HeaderMobileMenu = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeDropdownLink, setActiveDropdownLink] = useState<{
    href: string;
    label: string;
    target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
    groups: HeaderDropdownGroup[];
  } | null>(null);
  const onDropdownLinkClick = (linkItem: {
    href: string;
    label: string;
    target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
    groups: HeaderDropdownGroup[];
  }) => {
    setIsDropdownOpen(true);
    setActiveDropdownLink(linkItem);
  };
  const onCloseDropdownButtonClick = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div className={css.wrapper}>
      <div className={css.topBar}>
        <Link href={'/contact'} className={css.contactLink}>
          Contact
        </Link>
        <LanguageSwitcher />
      </div>

      {isDropdownOpen ? (
        <div className={css.dropdownContent}>
          <div className={css.dropdownContentHeader}>
            <button className={css.closeDropdownButton} onClick={onCloseDropdownButtonClick}>
              <ArrowLeft />
            </button>
          </div>

          <Link href={activeDropdownLink?.href || ''} className={css.dropdownParentLink}>
            {activeDropdownLink?.label}
          </Link>

          {activeDropdownLink?.groups.map((group, index) => (
            <ul key={index} className={css.dropdownGroup}>
              {group.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <Link href={item.href} target={item.target} className={css.dropdownGroupItemLink}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          ))}
        </div>
      ) : (
        <ul className={css.links}>
          <DropdownLinkItem
            href="/alquiler-oficinas"
            label="Workplaces"
            groups={[
              [
                { label: 'Ubicaciones', href: '/alquiler-oficinas' },
                { label: 'Barcelona', href: '/alquiler-oficinas/barcelona' },
                { label: 'Madrid', href: '/alquiler-oficinas/madrid' }
              ]
            ]}
            onClick={onDropdownLinkClick}
          />
          <DropdownLinkItem
            href="/espacios-de-trabajo"
            label="Qué ofrecemos"
            groups={[]}
            onClick={onDropdownLinkClick}
          />
          <DropdownLinkItem
            href="/quienes-somos"
            label="Sobre Utopicus"
            groups={[]}
            onClick={onDropdownLinkClick}
          />
          <LinkItem href="/grupo-colonial" label="Grupo Colonial" />
        </ul>
      )}
    </div>
  );
};

const LinkItem = (props: {
  href: string;
  label: string;
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
}) => (
  <li className={css.linkItem}>
    <a className={css.link} href={props.href} target={props.target}>
      {props.label}
    </a>
  </li>
);

function DropdownLinkItem(
  props: DropdownLinkItem & {
    onClick?: (
      linkItem: DropdownLinkItem,
      event: React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => void;
  }
) {
  return (
    <li className={css.linkItem} onClick={(e) => props.onClick?.(props, e)}>
      <p className={css.link}>
        {props.label}
        <CaretRight />
      </p>
    </li>
  );
}
